module.exports = __webpack_public_path__ + "img/Parsials.3939787e.jpg";